import * as React from 'react';
import * as classNames from 'classnames';
import useDismissibleAlert from './use_dismissible_alert';
import * as I18n from 'i18n-js';

interface IAlertBoxProps {
  type: 'info' | 'warning' | 'error' | 'success' | 'highlight' | 'plain';
  small?: boolean;
  unpadded?: boolean;
  inline?: boolean;
  children: React.ReactNode;
  dismissibleWithKey?: string;
}

export default function AlertBox({
  type,
  small,
  unpadded,
  inline,
  children,
  dismissibleWithKey,
}: IAlertBoxProps) {
  const classes = classNames(
    'alert-box',
    { 'alert-box--info': type === 'info' },
    { 'alert-box--warning': type === 'warning' },
    { 'alert-box--error': type === 'error' },
    { 'alert-box--success': type === 'success' },
    { 'alert-box--highlight': type === 'highlight' },
    { 'alert-box--plain': type === 'plain' },
    { 'alert-box--small': small },
    { 'alert-box--unpadded': unpadded },
    { 'alert-box--inline': inline },
    { 'alert-box--dismissible': !!dismissibleWithKey },
  );

  const [isDismissed, dismissAlertBox] = useDismissibleAlert(dismissibleWithKey);
  if (dismissibleWithKey && isDismissed) return null;

  return (
    <div className={classes}>
      <div className="alert-box__content">
        {children}
      </div>
      {!!dismissibleWithKey &&
        <button
          type="button"
          onClick={dismissAlertBox}
          className="alert-box__dismiss"
          aria-label={I18n.t('commons.alertBox.dismiss')}
        />
      }
    </div>
  );
}
